<template>
  <div class="p-6 md:p-0 md:pt-6">
    <div
      v-if="$store.state.sponsorPopUpOpen"
      class="fixed top-0 left-0 min-w-full overflow-hidden min-h-screen container">
      <div class="bg-blue-700 opacity-50 min-w-full min-h-screen" />
      <div
        class="absolute top-0 min-h-screen w-full"
        @click.self="$store.commit('setSponsorPopUpOpen', false)">
        <div class="mx-auto mt-2 sm:mt-4 max-w-2xl w-full">
          <div class="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg w-full text-center bg-white mx-auto p-2 sm:rounded-t">
            <button
              class="font-bold p-2 rounded shadow-md bg-white text-blue-600 border-2 border-blue-600 focus:outline-none active:shadow-none mr-2"
              @click="closeSponsorPopUp()">
              Kembali
            </button>
            <a
              :href="$store.state.tryoutUrl"
              class="font-bold p-2 rounded shadow-md bg-blue-600 text-white border-2 border-blue-600 focus:outline-none active:shadow-none">Lanjut ke Soal</a>
          </div>
          <template v-if="primaryExam != null && primaryExam.sponsors && primaryExam.sponsors.length && primaryExam.sponsors.findIndex((el) => el.is_pop_up) >= 0">
            <div class="flex flex-col">
              <div
                v-for="sponsor in primaryExam.sponsors"
                :key="sponsor.id">
                <a
                  v-if="sponsor.is_pop_up"
                  target="_blank"
                  :href="sponsor.url"
                  class="">
                  <img
                    class="max-w-xs sm:max-w-sm md:max-w-md lg:max-w-lg mx-auto"
                    :src="'/storage/' + sponsor.picture"
                    :alt="sponsor.name">
                </a>
              </div>
            </div>
          </template>
        </div>
      </div>
    </div>
    <div class="flex items-center justify-center md:justify-between mb-6 md:items-end md:justify-end">
      <img
        class="md:hidden block w-12"
        src="/img/logo-yuk-belajar.png"
        alt="Yuk Belajar">
      <h1 class="hidden md:block font-semibold text-xl text-blue-900">
        Akun
      </h1>
    </div>
    <div
      v-if="$store.state.user != null"
      class="w-full mb-6 leading-snug flex flex-col items-center justify-center text-gray-800">
      <div class="font-extrabold text-lg">
        {{ $store.state.user.name }}
      </div>
      <div class="font-medium text-base">
        {{ $store.state.user.email }}
      </div>
      <div class="my-1 flex items-center justify-center sm:max-w-full flex-wrap">
        <span
          v-for="role in $store.state.roles"
          :key="role.id"
          class="my-1 mx-1 text-xs py-1 px-2 font-bold bg-teal-100 text-gray-600 rounded-full">{{ role.name }}</span>
      </div>
      <a
        v-if="$store.state.roles.length"
        href="/office"
        class="rounded shadow bg-blue-700 text-white font-bold py-2 px-4 mt-2">Enter Office</a>
      <a
        v-if="$store.state.adminId"
        href="/back-to-office"
        class="rounded shadow bg-blue-700 text-white font-bold py-2 px-4 mt-2">Back To My Login</a>
    </div>
    <div
      v-if="$store.getters.ownedProductTotalAmount"
      class="mt-6 mb-3 bg-teal-100 border-t-4 border-teal-500 rounded-b text-teal-900 px-4 py-3 shadow"
      role="alert">
      <div class="flex items-center justify-start mb-1">
        <div class="py-1">
          <svg
            class="fill-current h-6 w-6 text-teal-500 mr-4"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 20 20"><path d="M2.93 17.07A10 10 0 1 1 17.07 2.93 10 10 0 0 1 2.93 17.07zm12.73-1.41A8 8 0 1 0 4.34 4.34a8 8 0 0 0 11.32 11.32zM9 11V9h2v6H9v-4zm0-6h2v2H9V5z" /></svg>
        </div>
        <p class="font-bold mb-1">
          Yuk Perhatikan!
        </p>
      </div>
      <ol class="list-decimal pl-4 pr-2 leading-tight text-sm md:text-base">
        <li class="mb-1">
          Masing-masing peserta harus memiliki akun Yuk Belajar dan melakukan Verifikasi Data Diri untuk dapat mengikuti Olimpiade Nasional Yuk Belajar.
        </li>
        <li class="mb-1">
          Jenis Soal Olimpiade akan sesuai dengan bidang yang telah kamu pilih pada tiket peserta. Soal Olimpiade dapat diakses melalui halaman akun ini sesuai dengan tanggal yang ditentukan.
        </li>
        <li class="mb-1">
          Setiap peserta harus mengerjakan sesuiai waktu dan tanggal yang diberikan. Waktu hitung mundur akan dimulai sejak soal dibuka.
        </li>
        <li class="mb-1">
          Daftar peringkat nilai peserta dan kunci jawaban olimpiade akan diberikan setelah rangkaian olimpiade selesai.
        </li>
        <li class="mb-1">
          Silahkan hubungi kami via 0858-6007-7481 (WA) jika kamu membutuhkan informasi lebih lanjut.
        </li>
        <!-- <li class="mb-1">Setiap peserta harus menunjukkan tiket dan kartu identitas untuk dapat masuk ke ruang <span class="italic">tryout</span>.</li>
              <li class="mb-1">Tiket dapat dicetak atau ditunjukkan melalui layar <span class="italic">handphone</span> Android / iOS.</li>
              <li class="mb-1">Tiket peserta kolektif dapat di-<span class="italic">download</span> setelah e-mail terdaftar sebagai akun.</li>
              <li class="mb-1">Tiket peserta kolektif juga dapat di-<span class="italic">download</span> setelah pembeli tiket memasukkan nama peserta lainnya.</li>
              <li class="mb-1">Seluruh peserta yang telah memiliki akun berkesempatan mengikuti latihan soal / simulasi <span class="italic">online</span>. Pemberitahuan mengenai jadwal simulasi tersebut akan dikabarkan lebih lanjut maksimal seminggu sebelum <span class="italic">tryout</span> dilaksanakan.</li>
              <li class="mb-1">Silakan menghubungi kami melalui kontak <span class="italic">customer service</span> atau akun sosial media Yuk Belajar.</li> -->
      </ol>
    </div>
    <div
      v-if="$store.state.ownedExams.length"
      class="text-center">
      <button
        v-if="!inputUserDataOpen && incompleteUserData"
        class="focus:outline-none px-4 py-3 mb-3 text-center rounded text-white bg-blue-600 shadow font-bold text-center"
        @click="openInputUserData()">
        Verifikasi Data Diri
      </button>
      <p
        v-if="!incompleteUserData && !inputUserDataOpen"
        class="focus:outline-none px-4 py-3 mb-3 text-center rounded bg-teal-100 text-teal-900 text-center md:text-left shadow">
        Data Diri Telah Diverifikasi
      </p>
    </div>
    <div
      v-if="inputUserDataOpen"
      class="mb-3 px-3 py-3 w-full bg-gray-100 rounded shadow text-gray-900">
      <div class="flex-col items-center justify-between">
        <profile-data-verification-input
          id="name"
          v-model="user.name"
          label="Nama Lengkap" />
        <profile-data-verification-select
          id="province_id"
          v-model="user.province_id"
          label="Provinsi"
          :options="{
            data: provinces,
            value: 'id',
            text: 'name',
          }"
          @input="loadDistricts(user.province_id)" />
        <profile-data-verification-select
          id="district_id"
          v-model="user.district_id"
          label="Kota/Kabupaten"
          :options="{
            data: districts,
            value: 'id',
            text: 'name',
          }" />
        <profile-data-verification-input
          id="school"
          v-model="user.school"
          label="Asal Sekolah" />
        <profile-data-verification-input
          id="grade"
          v-model="user.grade"
          label="Kelas" />
        <!-- <profile-data-verification-select
          id="university_id"
          v-model="user.university_id"
          label="Pilihan Universitas"
          :options="{
            data: universities,
            value: 'id',
            text: 'name',
          }"
          @input="loadDepartments(user.university_id)" />
        <profile-data-verification-select
          id="department_id"
          v-model="user.department_id"
          label="Pilihan Jurusan"
          :options="{
            data: departments,
            value: 'id',
            text: 'name',
          }" /> -->
        <profile-data-verification-input
          id="phone"
          v-model="user.phone"
          label="No. HP" />
        <profile-data-verification-input
          id="whatsapp"
          v-model="user.whatsapp"
          label="WhatsApp" />
        <profile-data-verification-input
          id="instagram"
          v-model="user.instagram"
          label="Instagram" />
        <div class="flex items-center justify-end">
          <button
            class="bg-white text-blue-500 focus:outline-none active:shadow-outline active:text-blue-400 disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 border border-blue-500 shadow rounded-full w-6 h-6 mr-3"
            @click="closeInputUserData()">
            <svg
              class="fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"><path d="M256 90c44.3 0 86 17.3 117.4 48.6C404.7 170 422 211.7 422 256s-17.3 86-48.6 117.4C342 404.7 300.3 422 256 422s-86-17.3-117.4-48.6C107.3 342 90 300.3 90 256s17.3-86 48.6-117.4C170 107.3 211.7 90 256 90m0-42C141.1 48 48 141.1 48 256s93.1 208 208 208 208-93.1 208-208S370.9 48 256 48z" /><path d="M360 330.9L330.9 360 256 285.1 181.1 360 152 330.9l74.9-74.9-74.9-74.9 29.1-29.1 74.9 74.9 74.9-74.9 29.1 29.1-74.9 74.9z" /></svg>
          </button>
          <button
            class="bg-white text-green-600 focus:outline-none active:shadow-outline active:text-green-500 disabled:bg-gray-500 disabled:shadow-none disabled:cursor-not-allowed disabled:opacity-75 border border-green-600 shadow rounded-full w-6 h-6"
            @click="submitUserData()">
            <svg
              class="fill-current"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 512 512"><path d="M256 48C141.6 48 48 141.6 48 256s93.6 208 208 208 208-93.6 208-208S370.4 48 256 48zm-42.7 318.9L106.7 260.3l29.9-29.9 76.8 76.8 162.1-162.1 29.9 29.9-192.1 191.9z" /></svg>
          </button>
        </div>
      </div>
    </div>
    <div>
      <digital-product
        v-for="ownedExam in $store.state.ownedExams"
        :key="ownedExam.user_product_detail_id"
        :user_product_detail_id="ownedExam.user_product_detail_id"
        :major_id="ownedExam.major_id"
        :city_name="ownedExam.city_name"
        :sharing_session_url="ownedExam.sharing_session_url"
        :exam_id="ownedExam.id" />
    </div>
    <div>
      <purchased-product
        v-for="purchasedProduct in $store.state.purchasedProducts"
        :id="purchasedProduct.id"
        :key="purchasedProduct.id"
        :exam="purchasedProduct.product.exams[0]" />
    </div>
    <div>
      <gift-product
        v-for="giftProduct in $store.state.giftProducts"
        :id="giftProduct.id"
        :key="giftProduct.id"
        :exam="giftProduct.userProduct.product.exams[0]" />
    </div>
    <div class="text-center">
      <logout-button />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import ProfileDataVerificationInput from './ProfileDataVerificationInput'
import ProfileDataVerificationSelect from './ProfileDataVerificationSelect'

export default {
  components: {
    ProfileDataVerificationInput,
    ProfileDataVerificationSelect,
  },
  props: [],
  data: function() {
    return {
      inputUserDataOpen: false,
      user: {
        name: null,
        school: null,
        phone: null,
        whatsapp: null,
        instagram: null,
        grade: null,
        province_id: null,
        district_id: null,
        university_id: null,
        department_id: null,
      },
      provinces: [],
      districts: [],
      universities: [],
      departments: [],
    };
  },
  computed: {
    incompleteUserData() {
      return this.user == null ? false : !this.user.school;
    },
    ...mapState(['primaryExam', 'errors']),
  },
  async mounted() {
    this.$store.commit('setCurrentPath', 'profile');
    this.$store.commit('setLoading', true);
    try {
      await this.$store.dispatch('loadCities');
      await this.$store.dispatch('loadMajors');
      await this.$store.dispatch('loadRoles');
      await this.$store.dispatch('loadAdminId');
      let res = await axios.get('/resource/provinces');
      this.provinces = res.data.data;
      res = await axios.get('/resource/universities');
      this.universities = res.data.data;
    } catch (error) {
      this.$store.commit('setLoading', false);
      throw error;
    }
    this.$store.commit('setLoading', false);
    this.user.name = this.$store.state.user.name;
    this.user.school = this.$store.state.user.school;
    this.user.phone = this.$store.state.user.phone;
    this.user.whatsapp = this.$store.state.user.whatsapp;
    this.user.instagram = this.$store.state.user.instagram;
    this.user.grade = this.$store.state.user.grade;
    this.user.province_id = this.$store.state.user.province_id;
    this.user.district_id = this.$store.state.user.district_id;
    this.user.university_id = this.$store.state.user.university_id;
    this.user.department_id = this.$store.state.user.department_id;
  },
  methods: {
    async loadDistricts(province_id) {
      let res = await axios.get('/resource/provinces/'+province_id+'/districts');
      this.districts = res.data.data;
    },
    async loadDepartments(university_id) {
      let res = await axios.get('/resource/universities/'+university_id+'/departments');
      this.departments = res.data.data;
    },
    openInputUserData() {
      this.inputUserDataOpen = true;
    },
    closeInputUserData() {
      this.inputUserDataOpen = false;
    },
    async submitUserData() {
      this.$store.commit('setLoading', true);

      try {
        await this.$store.dispatch('pushUpdateUser', this.user);
        this.$forceUpdate();
        this.closeInputUserData();
      } catch (error) {
        this.$store.commit('setLoading', false);
        if (error.response.status == 422) {
          this.$store.commit('setErrors', error.response.data.errors);
        } else {
          throw error;
        }
      }
      this.$store.commit('setLoading', false);
    },
    closeSponsorPopUp() {
      this.$store.commit('setSponsorPopUpOpen', false);
    },
  },
}
</script>
